import type { SitecoreDictionary } from '@/lib/dictPlugin';
import type { LinkField } from '@/sitecoreFieldTypes';
export type FieldsWithLinks = Record<string, LinkField> | Record<string, any>;
export type LinkData = {
  url?: string | undefined;
  text?: string | undefined;
  altTitle?: string | undefined;
  target?: string | undefined;
};

export const getLinkData = (fields: FieldsWithLinks, fieldName: string): LinkData => {
  const linkObj = fields[fieldName];
  let resultObj = {};

  if (linkObj) {
    resultObj = {
      url: linkObj.value.href,
      text: linkObj.value.text,
      altTitle: linkObj.value.title,
      target: linkObj.value.target,
    };

    if (IS_SHOWROOM) {
      resultObj = linkObj.value;
    }
  }

  return resultObj;
};

export const getLinkLabel = (
  dict: SitecoreDictionary,
  fields: FieldsWithLinks,
  label: string,
  links: string[],
  classes: string[] = [],
) => {
  const linksArray: string[] = [];

  links.forEach((link) => {
    const linkData = getLinkData(fields, link);
    const linkTitleParam = linkData.altTitle?.length ? `title="${linkData.altTitle}"` : '';
    const linkTargetParam = linkData.target?.length ? `target="${linkData.target}"` : '';
    const template = `<a
              class="${classes.join(' ')}"
              href="${linkData.url}"
              ${linkTitleParam}"
              ${linkTargetParam}"
            >${linkData.text}</a>`;

    linksArray.push(template);
  });

  return fields && fields[label] ? dict.replace(fields[label].value, linksArray) : '';
};

export const hasNecessaryLinkDetails = (link: null | undefined | LinkData) =>
  !!(link && link.url && link.text);

export const getMailToHref = (email: string | null | undefined) => {
  if (!email) {
    return undefined;
  }

  const formattedMail = email.trim().replace(/^mailto:/, '');
  return `mailto:${formattedMail}`;
};

const getSchemeHref = (scheme: string, nr: string | null | undefined) => {
  if (!nr) {
    return undefined;
  }

  const formattedNr = nr
    .trim()
    .replace(new RegExp('[. ()/-]', 'g'), '')
    .replace(/^[a-zA-Z]*:/, '');
  return `${scheme}:${formattedNr}`;
};

export const getTelHref = (tel: string | null | undefined) => getSchemeHref('tel', tel);

export const getFaxHref = (fax: string | null | undefined) => getSchemeHref('fax', fax);

export const useLinkHelper = () => {
  return {
    getLinkData,
    getLinkLabel,
    hasNecessaryLinkDetails,
    getMailToHref,
    getTelHref,
    getFaxHref,
  };
};
